const VALID = ["TAKEAWAY", "DINEIN", "DRIVE", "DELIVERY"];

export function readMenuOrderType(restaurantId) {
  if (!restaurantId) return "TAKEAWAY";
  try {
    const v = localStorage.getItem(`leMemePrix_menuOrderType_${restaurantId}`);
    if (v && VALID.includes(v)) return v;
  } catch {
    /* ignore */
  }
  return "TAKEAWAY";
}

export function writeMenuOrderType(restaurantId, type) {
  if (!restaurantId || !VALID.includes(type)) return;
  try {
    localStorage.setItem(`leMemePrix_menuOrderType_${restaurantId}`, type);
  } catch {
    /* ignore */
  }
}
